<template>
  <div class="p-b-5">
    <v-table
      :data="tcpaHistoryData"
      :current-page.sync="currentPage"
      :page-size="10"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            v-t="'TCPA_SHIELD_HISTORY_TABLE_DATE'"
            sort-key="time"
            default-sort="asc"
          >
            Date
          </v-th>
          <v-th
            v-t="'TCPA_SHIELD_HISTORY_TABLE_ORIGIN'"
            sort-key="name"
          >
            Origin
          </v-th>
          <v-th
            v-t="'TCPA_SHIELD_HISTORY_TABLE_CHECKED'"
            sort-key="numbersChecked"
          >
            Numbers Checked
          </v-th>
          <v-th
            v-t="'TCPA_SHIELD_HISTORY_TABLE_SCRUBBED'"
            sort-key="numbersScrubed"
          >
            Numbers Scrubed
          </v-th>
          <v-th
            v-t="'TCPA_SHIELD_HISTORY_TABLE_COST'"
            sort-key="cost"
          >
            Cost
          </v-th>
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.id"
        >
          <td>{{ getFormattedDate(row.time) }}</td>
          <td>
            {{ row.name ? row.name : 'API' }}
          </td>
          <td>
            {{ row.numbersChecked }}
          </td>
          <td>
            {{ row.numbersScrubed }}
          </td>
          <td>${{ row.cost }}</td>
        </tr>
      </tbody>
    </v-table>
    <div class="pagination-min">
      <div class="text-center p-7">
        <smart-pagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
          :max-page-links="10"
        />
      </div>
    </div>

    <div
      v-if="loadingStatus === 'pending'"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'TCPA_SHIELD_HISTORY_TABLE_LOADING'" />
    </div>
    <div
      v-if="loadingStatus === 'success' && tcpaHistoryData.length === 0"
      v-t="'TCPA_SHIELD_HISTORY_TABLE_EMPTY'"
      class="well well-sm text-center"
    />
  </div>
</template>

<script>
import Loader from '@/core/components/Loader';
import messages from '../../locales';

export default {
  name: 'TcpaHistoryTable',
  components: {
    Loader,
  },
  props: {
    tcpaHistoryData: {
      type: Array,
      default() {
        return [];
      },
    },
    loadingStatus: {
      type: String,
      default() {
        return '';
      },
    },
    momentTimezoneId: {
      type: String,
      default: 'America/Los_Angeles',
    },
  },
  data: function () {
    return {
      currentPage: 1,
      totalPages: 0,
    };
  },
  methods: {
    getFormattedDate(value) {
      return moment(String(value)).tz(this.momentTimezoneId).format('D MMM, h:mm A');
    },
  },
  i18n: {
    locale: 'en',
    messages,
  },
};
</script>

<style>
</style>